import { NgModule } from '@angular/core';
import { LibCalendarIconComponent } from './lib-calendar-icon.component';

@NgModule({
  declarations: [LibCalendarIconComponent],
  exports: [LibCalendarIconComponent],
})
export class LibCalendarIconModule {}
